import { NgModule } from '@angular/core';
import {
  SearchAdditionalFieldComponent
} from '@app/pcs/shared/search/additional-field/search-additional-field.component';
import { SearchFieldChoiceComponent } from '@app/pcs/shared/search/field-choice/search-field-choice.component';
import { SearchFieldsGroupComponent } from '@app/pcs/shared/search/search-fields-group/search-fields-group.component';
import { SharedModule } from '@app/shared/shared.module';

@NgModule({
  imports: [
    SharedModule
  ],
  declarations: [
    SearchFieldChoiceComponent,
    SearchAdditionalFieldComponent,
    SearchFieldsGroupComponent
  ],
  exports: [
    SearchFieldChoiceComponent,
    SearchAdditionalFieldComponent,
    SearchFieldsGroupComponent
  ]
})
export class SearchAdditionalFieldsModule {

}
